import api from 'api';

export const getConfigurations = (params) => {
  return api.get('/configurations', params, 'bearer');
};

export const getConfiguration = (id, params) => {
  return api.get(`/configurations/${id}`, params, 'bearer');
};

export const updateConfiguration = (id, body) => {
  return api.put(`/protected_configurations/${id}`, body, 'bearer');
};
